import React, { useEffect, useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import styled from "styled-components";

const Media = {
  Laptop: "@media(max-width:1220px)",
  LaptopMin: "@media(max-width:1210px)",
  Tablet: "@media(max-width:1000px)",
  Phone: "@media(max-width: 768px)",
};

const ScrollTopContainer = styled.section`
  .scroll-top {
    width: 45px;
    height: 45px;
    position: fixed;
    bottom: 2em;
    right: 2em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50% !important;
    background-color: var(--verde-color);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    
    z-index: 98;
    cursor: pointer;

    &:hover {
      background-color: var(--branco-color);
    }
  }

  .arrow {
    margin-top: -3px;
    font-size: 40px;
    color: var(--branco-color);
    transition: color 0.3s ease;

    &:hover {
      color: var(--preto-color);
    }

    ${Media.Phone} {
      font-size: 32px;
    }
  }
`;

 export const ScrollToTop = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.pageYOffset > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ScrollTopContainer>
      {showScroll && (
        <div
          className="scroll-top"
          onClick={() =>
            window.scrollTo({ top: 0, behavior: "smooth" })
          }
        >
          <IoIosArrowUp className="arrow" />
        </div>
      )}
    </ScrollTopContainer>
  );
};
